import React from 'react';
import {
  Box,
  Button,
  Typography,
  Grid,
  Container,
} from "@mui/material";
import { Link } from "react-router-dom";
import whoImg from "../assests/whoImg.png";

export default function WhoWeAre() {
  return (
    <div>
      <Container maxWidth="xl">
        <Box sx={{
          padding: "80px 0"
        }}>
          <Grid container spacing={12} sx={{
            display: "flex",
            // alignItems:"center",
          }}>
            <Grid size={{ md: 6, lg: 6 }}>


              <Box sx={{
                textAlign: "left",
              }}>
                <Typography sx={{
                  fontSize: '18px',
                  lineHeight: '100%',
                  fontWeight: '500',
                  fontFamily: `"Quicksand", sans-serif`,
                  color: '#008BFF',
                  marginBottom: "10px"
                }}>About Us</Typography>
                <Typography sx={{
                  fontSize: '40px',
                  lineHeight: '100%',
                  fontWeight: '700',
                  fontFamily: `"Quicksand", sans-serif`,
                  color: '#253D4E',
                }}>Who We are</Typography>
                <Typography sx={{
                  fontSize: '16px',
                  lineHeight: '20px',
                  fontWeight: '400',
                  fontFamily: `"Lato", sans-serif`,
                  color: '#211715',
                  margin: "20px 0 20px"
                }}>Life Line Products supplies regulated medical devices, disposables, and equipment for hospitals, clinics, and independent practices. Operations center on reliable delivery, part-level traceability, and transparent pricing from manufacturer to point of care.
                </Typography>
                <Typography sx={{
                  fontSize: '16px',
                  lineHeight: '20px',
                  fontWeight: '400',
                  fontFamily: `"Lato", sans-serif`,
                  color: '#211715',
                  marginBottom: "30px"
                }}>
                  Life Line Products focuses on consistent supply, clear documentation, and responsive support for facilities that require accurate product data and dependable delivery for patient care.</Typography>
                <Button sx={{
                  width: '208px',
                  height: '46px',
                  borderRadius: '4px',
                  backgroundColor: 'transparent',
                  border: "1px solid #008BFF",
                  color: '#fff',
                  fontSize: '16px',
                  lineHeight: '21.6px',
                  letterSpacing: '0.5px',
                  fontWeight: '700',
                  fontFamily: `"Quicksand", sans-serif`,
                  textTransform: 'capitalize',
                  "& a": {
                    color: '#008BFF',
                    letterSpacing: "0.5"
                  },
                }}>
                  <Link to="/shop">
                    View Our Products
                  </Link>
                </Button>
              </Box>

            </Grid>
            <Grid size={{ md: 6, lg: 6 }} sx={{
              "& img": {
                width: "100%",
              },
            }}>
              <img src={whoImg} alt="who we are" />
            </Grid>
          </Grid>
        </Box>
      </Container>
    </div>
  )
}
